import React, { Component } from "react";
import { Grid } from "semantic-ui-react";
import FreqButton from "./FormButton";

export default class ButtonGroup extends Component {
  render() {
    const { input: { value: selectedService, onChange } } = this.props;
    return (
      <Grid stackable columns={4} style={{ marginTop: "20px" }}>
        <Grid.Column>
          <FreqButton
            handleItemClick={() => {
              onChange("oneTime");
            }}
            active={selectedService === "oneTime"}
          >
            One Time
          </FreqButton>
        </Grid.Column>
        <Grid.Column>
          <FreqButton
            handleItemClick={() => {
              onChange("everyWeek");
            }}
            active={selectedService === "everyWeek"}
          >
            Every Week
          </FreqButton>
        </Grid.Column>
        <Grid.Column>
          <FreqButton
            handleItemClick={() => {
              onChange("twoWeeks");
            }}
            active={selectedService === "twoWeeks"}
          >
            Every 2 Weeks
          </FreqButton>
        </Grid.Column>
        <Grid.Column>
          <FreqButton
            handleItemClick={() => {
              onChange("fourWeeks");
            }}
            active={selectedService === "fourWeeks"}
          >
            Every 4 Weeks
          </FreqButton>
        </Grid.Column>
      </Grid>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Booking/FormContainer/FreqButtonGroup.jsx